export function getDesignBreakpoints() {
    return {
        keys: ['s', 'm', 'l', 'xl', 'xxl'],
        unit: 'px',
    };
}
